import globalConf from '@/config/globalConf';

// user
export const SYS_LOGIN = '/api/system/login';

export const SYS_REGISTER = '/api/system/register';

export const SYS_LOGOUT = '/api/system/logout';

// --no use
export const SYS_CAPTCHA = '/api/captcha';

export const CHANGE_USER_INFO = '/api/system/user/updateUserInfo.do';

export const CHANGE_PASSWD = '/api/system/user/resetUserPassword.do';

export const MOBILE_CAPTCHA = '/api/system/verificationCode';

// dict
export const DICT = '/api/dict/list.do';

// redirect URL
export const DOWNLOAD = `${globalConf.axiosBaseURL}/api/common/download.do`;
